import { MagnifingglassIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { useImpressionRef } from '@zep/logger/react';
interface QuizBankEmptyResultProps {
  /** 검색어가 있으면 되비추고, 없으면 필터를 넓히라고 안내한다 */
  query?: string;
  /** 이 화면이 실제로 보였을 때 1회. 마운트가 아니라 노출이 지표다. */
  onImpress?: () => void;
}
const NOOP = () => {};

/** 결과 0건. 같은 빌드 화면의 성취기준 검색(`SearchEmpty`)과 생김새를 맞춘다. */
export const QuizBankEmptyResult = ({
  query,
  onImpress
}: QuizBankEmptyResultProps) => {
  const {
    t
  } = useTranslation(['build']);
  const hasQuery = Boolean(query?.trim());
  const impressionRef = useImpressionRef<HTMLDivElement>(onImpress ?? NOOP);
  return <div ref={impressionRef} className="flex size-full flex-col items-center justify-center gap-lg px-lg py-3xl" data-sentry-component="QuizBankEmptyResult" data-sentry-source-file="QuizBankEmptyResult.tsx">
      <MagnifingglassIcon width={70} height={70} fill="#1C1B1F12" data-sentry-element="MagnifingglassIcon" data-sentry-source-file="QuizBankEmptyResult.tsx" />

      <div className="flex flex-col items-center gap-3xs">
        <h4 className="max-w-[420px] truncate text-center text-heading-md-bold text-default">
          {hasQuery ? t('build:quizBank.empty.searchTitle', {
          query: query?.trim() ?? ''
        }) : t('build:quizBank.empty.filterTitle')}
        </h4>

        <p className="text-center text-heading-sm-bold text-alternative">
          {hasQuery ? t('build:quizBank.empty.searchDescription') : t('build:quizBank.empty.filterDescription')}
        </p>
      </div>
    </div>;
};